<template>
  <div>
    <template v-if="submenu.sonMenu.length===0">
      <el-menu-item :index="submenu.path" :key="submenu.path" v-if="isLeftMenuItem(submenu)">
        <i :class="submenu.icon">
          <span v-if="redDotNum!==0" class="red-dot">{{ getRedDotNum(submenu.redDotFc, submenu.isInClass) }}</span>
        </i>
        <span slot="title" class="title">
          <span class="title-row">
            <span class="title-text">{{ submenu.title }}</span>
            <span v-if="submenu.isNeedNewIcon&&!isCollapse" class="new-badge"><span class="text">New</span></span>
          </span>
        </span>

      </el-menu-item>
    </template>
    <template v-else>
      <el-submenu :index="submenu.path" v-if="isLeftMenuItem(submenu)" :class="isCollapse?'sonMenu':''">
        <template slot="title">
          <i :class="submenu.icon">
            <span v-if="redDotNum!==0" class="red-dot">{{ getRedDotNum(submenu.redDotFc, submenu.isInClass) }}</span>
          </i>
          <span slot="title" class="title" style="padding-right: 10px">{{ submenu.title }}</span>
        </template>
        <sidebar-item
            class="hasSonMenu"
            v-for="child in submenu.sonMenu"
            :key="child.path"
            :isCollapse="isCollapse"
            :submenu="child"/>
      </el-submenu>
    </template>
  </div>
</template>

<script>

import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "SidebarItem",
  props: ['submenu','isCollapse'],
  data() {
    return {}
  },
  computed: {
    redDotNum() {
      return this.getRedDotNum(this.submenu.redDotFc, this.submenu.isInClass);
    }
  },
  methods: {
    isLeftMenuItem(subItem) {
      this.user = JSON.parse(getDataInLocalStorage('user'))
      let role = this.$store.getters["right/getRole"]
      let isViewer = false
      if (subItem.viewer) {
        isViewer = this.user[subItem.viewer.content]
      }
      let {type,realName}={...this.user}
      return ((subItem.role.length === 0&&(!subItem.condition||eval(subItem.condition))) || (subItem.role.includes(this.$store.getters["right/getRole"]))&&(!subItem.condition||eval(subItem.condition)) || isViewer);
    },
    getRedDotNum(redDotType, isInClass) {
      if (redDotType) {
        if (isInClass) {
          return this.$store.getters[`dataStatus/${redDotType}`].total
        } else {
          return this.$store.getters[`dataStatus/${redDotType}`]
        }

      }
      return 0

    }
  }
}
</script>

<style scoped>
.red-dot {
  top: -5px;
  right: -5px;
}

/deep/ .el-submenu__icon-arrow {
  position: absolute !important;
  top: 30px !important;
  right: 10px;
}

.title-row {
  display: inline;
  line-height: 1.4;
  word-break: break-all;
}

.title-text {
  vertical-align: middle;
}

.new-badge {
  display: inline-block;
  vertical-align: middle;
  align-items: center;
  margin-left: 10px;
  padding: 0px 5px;
  width: 40px;
  height: 18px;
  line-height: 18px;
  font-size: 10px;
  font-weight: 550;
  letter-spacing: 1px;
  color: #fff;
  background-color: rgb(241, 30, 31);
  border-radius:3px;
  white-space: nowrap;
  position: relative;
}

.new-badge::before {
  content: '';
  position: absolute;
  left: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid rgb(241, 30, 31);
}
.new-badge .text{
  position: absolute;
  top: -1px;
}

.sonMenu .title {
  display: none !important;
}

.sonMenu /deep/ .el-submenu__title {
  padding: 0 20px !important;
  display: inline-block !important;
  width: 100%;
}
</style>
